module.exports = __webpack_public_path__ + "img/599.61eec4b5.jpg";